import {AfterViewInit, Component, ElementRef, Inject, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import FileUtils, {ContentType} from 'src/app/core/services/file-utils';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {Message} from 'src/app/core/class/message';
import {WarningComponent} from 'src/app/shared/components/warning/warning.component';
import {SignProgressComponent} from '../../sign-document/sign-progress/sign-progress.component';
import {BehaviorSubject, fromEvent, Observable, Observer} from 'rxjs';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {SignDocumentService} from 'src/app/core/services/sign-document.service';
import {NotificationService} from 'src/app/core/services/notification.service';
import {DigitalCertificateService} from 'src/app/core/services/digital-certificate.service';
import {ConfirmSignOtpWithImageComponent} from '../../confirm-sign-otp-with-image/confirm-sign-otp-with-image.component';
// @ts-ignore
import {NzUploadFile} from 'ng-zorro-antd/upload';
import {pairwise, switchMap, takeUntil} from 'rxjs/operators';
import { format } from 'date-fns';
import {SlickCarouselComponent} from 'ngx-slick-carousel';
import {UsbTokenService} from 'src/app/core/services/usb-token.service';
import {DocumentService} from 'src/app/core/services/document.service';
import {CommonService} from '../../../../../../../core/services/common.service';


declare var $: any;
// fix sonar
// declare function signHash(comp, hashBase64): any;

declare function initPlugin(comp): any;

@Component({
  selector: 'app-select-stamp-sign-moha',
  templateUrl: './select-stamp-sign-moha.component.html',
  styleUrls: ['./select-stamp-sign-moha.component.scss']
})

export class SelectStampSignMohaApproveComponent implements OnInit, AfterViewInit, OnDestroy {
  private stampDivWrapper: HTMLElement;
  public loading = false;
  public avatarUrl: string;
  public disableBtnDeleteCanvas = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      positionX: number,
      positionY: number,
      pageIndex: number,
      pageNumber: number,
      contractId: string,
      zoom: number,
      imageWith: number,
      pdfSrc: string,
      documentEntity: any,
      document: any,
      type: string,
      stampPositionLeft: number,
      stampPositionTop: number,
      widthRectangle: number,
      heightRectangle: number,
    },
    private toastr: ToastrService,
    public message: Message,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<SelectStampSignMohaApproveComponent>,
    private signDocumentService: SignDocumentService,
    public notificationService: NotificationService,
    private digitalCertificateService: DigitalCertificateService,
    public usbTokenService: UsbTokenService,
    private documentService: DocumentService,
    public translate: TranslateService,
    private commonService: CommonService,
  ) {
    this.pdfSrc = data.pdfSrc;
    this.zoomLevel = data.zoom;
    if (data.type === this.SIGN_SLOT) {
      this.dataSignSlot = data.document;
    } else {
      this.dataSignSingle = data.document;
    }

    this.signType = data.type;
    dialogRef.disableClose = false;
    this.userType = localStorage.getItem('userType');
    // this.data.pageNumber = this.data.pageIndex;
  }

  @ViewChild('slickModal', {static: false}) slickModal: SlickCarouselComponent;
  @ViewChild('slickSlide', {static: false}) slickSlide: SlickCarouselComponent;
  private isDisable: boolean;
  public fileUpload: File;
  private isFormChanging: false;
  public CONFIRM_ACTION = 'confirm';
  public CLOSE_ACTION = 'close';
  public SIGN_SLOT = 'slot';
  public SIGN_SINGLE = 'single';
  public SIGN_SERVER = 0;
  public SIGN_USB_TOKEN = 1;
  public SIGN_SIM_CA = 2;
  public SIGN_OTP = 3;
  public SIGN_HSM = 4;
  public SIGN_NO_CERT = 6;

  public signMethod = {
    SIGN_SERVER: 0,
    SIGN_USB_TOKEN: 1,
    SIGN_SIM_CA: 2,
    SIGN_OTP: 3,
    SIGN_HSM: 4,
    SIGN_IMAGE: 5,
    SIGN_NO_CERT: 6
  };
  beforeUpload = this.commonService.beforeUploadImage;
  signType: any;
  certificate: any;
  private dataSignSingle: any;
  private sign = {
    contractId: '',
    digitalCertificateId: '',
    digitalCertificateDetailId: '',
    certificate: '',
    path: '',
    signature: '',
    signPdf: '',
    phoneNumber: '',
    serialNumber: '',
    positionX: null,
    positionY: null,
    pageIndex: null,
    zoom: null,
    imageWith: null,
    pdfSrc: null,
    documentEntity: null,
    document: null,
    type: null,
    image: null,
    base64Image: null,
    signPositions: null,
    widthRectangle: null,
    heightRectangle: null
  };
  public selectedCert: any;
  private actions = new BehaviorSubject<string>('');
  @BlockUI() blockUI: NgBlockUI;
  success = false;
  // stampSign: HTMLElement;
  public userType: any;
  private dataSignSlot: any;
  enterpriseId = localStorage.getItem('enterpriseId');
  @ViewChild('myCanvas', {static: false}) canvas: ElementRef;
  private cx: CanvasRenderingContext2D;
  @Input() public width = 440;
  @Input() public height = 200;
  currentColour = '#000';
  brushSize = 5;
  pageIndex = 0;

  imageUrl: string;
  zoomLevel: number;
  pdfSrc: any;
  certificates = [];
  tabsCertificates = [];
  imageCertificates = [{
    type: 6,
    listCert: []
  }];
  typeCertificate: number;
  columnsToDisplay = ['issuedTo', 'taxCode', 'phoneNumber', 'expireDate'];

  current = 0;
  index = '<h1>First-content</h1>';
  previewImage: string | undefined = '';
  previewVisible = false;
  // slick

  listSlickRender = [];
  disableButtonSign = true;

  slideConfig = {
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    infinite: false,
    focusOnSelect: true,
    asNavFor: '.slider-single'
  };
  slideConfigLarge = {
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: true,
    infinite: false
  };

  // slick
  selectedIndex = 1;

  selectNewImageSign = false;
  pagePdfViewer: HTMLElement;

  // current status when signed
  // isCurrentStatus: number = 2;

  sanitize = this.commonService.sanitize;

  ngOnInit() {
    this.notificationService.subscribeErrorService();
    this.getCertificates();
  }

  configCanvas() {
    const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
    this.cx = canvasEl.getContext('2d');
    canvasEl.width = this.width;
    canvasEl.height = this.height;
    this.cx.lineWidth = 5;
    this.cx.lineCap = 'round';
    this.cx.strokeStyle = '#000';
    this.captureEvents(canvasEl);
  }

  ngAfterViewInit() {
  }

  textLayerRendered(e) {
    const element = e.source.textLayerDiv;
    element.style.opacity = '1';
    const offsetParent = element.offsetParent.dataset;
    const {pageNumber} = offsetParent;
    if (this.data.pageNumber === pageNumber) {
      this.pagePdfViewer = element;
      const stampWrapper = document.createElement('div');
      this.stampDivWrapper = stampWrapper;
      const signatureWidth = this.data.widthRectangle * this.data.zoom;
      const heightRectangle = this.data.heightRectangle * this.data.zoom;
      element.appendChild(this.stampDivWrapper);
      stampWrapper.setAttribute('id', 'stamp-sign-div-wrapper');
      stampWrapper.style.position = 'absolute';
      stampWrapper.style.background = 'rgb(0,0,0,0.2)';
      stampWrapper.style.left = `${this.data.stampPositionLeft}px`;
      stampWrapper.style.top = `${this.data.stampPositionTop}px`;
      stampWrapper.style.paddingTop = '8px';
      stampWrapper.style.width = `${signatureWidth}px`;
      stampWrapper.style.height = `${heightRectangle}px`;
      stampWrapper.style.fontSize = `${14 * this.data.zoom}px`;
      stampWrapper.style.opacity = '1';
      stampWrapper.style.border = '1px solid #999999';
      stampWrapper.style.zIndex = '1';
      stampWrapper.style.lineHeight = '1.6';
      stampWrapper.style.color = '#000000';
      stampWrapper.style.fontFamily = '\"Times New Roman\", Times, serif';

      // scroll to view position
      const stampWrapperView = document.createElement('div');
      const preview1 = document.getElementById('scrolling_div');
      let leftPosition = this.data.stampPositionLeft;
      if (leftPosition > preview1.offsetWidth / 2) {
        leftPosition -= preview1.offsetWidth / 2;
      }
      element.appendChild(stampWrapperView);
      stampWrapperView.style.position = 'absolute';
      stampWrapperView.style.left = `${leftPosition}px`;
      stampWrapperView.style.top = `${this.data.stampPositionTop - preview1.offsetHeight / 2}px`;
      stampWrapperView.scrollIntoView();
    }
    this.pageIndex++;
  }

  private captureEvents(canvasEl: HTMLCanvasElement) {
    // this will capture all mousedown events from the canvas element
    fromEvent(canvasEl, 'mousedown')
      .pipe(
        switchMap((e) => {
          // after a mouse down, we'll record all mouse moves
          return fromEvent(canvasEl, 'mousemove')
            .pipe(
              // we'll stop (and unsubscribe) once the user releases the mouse
              // this will trigger a 'mouseup' event
              takeUntil(fromEvent(canvasEl, 'mouseup')),
              // we'll also stop (and unsubscribe) once the mouse leaves the canvas (mouseleave event)
              takeUntil(fromEvent(canvasEl, 'mouseleave')),
              // pairwise lets us get the previous value to draw a line from
              // the previous point to the current point
              pairwise()
            );
        })
      )
      .subscribe((res: [MouseEvent, MouseEvent]) => {
        const rect = canvasEl.getBoundingClientRect();

        // previous and current position with the offset
        const prevPos = {
          x: res[0].clientX - rect.left,
          y: res[0].clientY - rect.top
        };

        const currentPos = {
          x: res[1].clientX - rect.left,
          y: res[1].clientY - rect.top
        };

        // this method we'll implement soon to do the actual drawing
        this.drawOnCanvas(prevPos, currentPos);
      });
  }

  private drawOnCanvas(prevPos: { x: number, y: number }, currentPos: { x: number, y: number }) {
    this.disableBtnDeleteCanvas = false;
    if (!this.cx) {
      return;
    }
    this.cx.beginPath();
    if (prevPos) {
      this.cx.moveTo(prevPos.x, prevPos.y); // from
      this.cx.lineTo(currentPos.x, currentPos.y);
      this.cx.closePath();
      this.cx.strokeStyle = this.currentColour;
      this.cx.lineWidth = this.brushSize;
      this.cx.stroke();
    }
  }

  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
  }

  dialogHandleAfterClose(dialogRef: any) {
    return dialogRef.afterClosed().subscribe((result) => {
      // if (dialogRef.componentInstance.success) {
      //   this.onBackClick();
      // }
      if (result) {
        const imageUrl = result.image;
        const image = document.getElementById('#imageDrawPreview');
        image.setAttribute('src', imageUrl);

        fetch(imageUrl)
          .then(r => r.blob())
          .then(blobFile => {
            const imageFile = new File([blobFile], 'fileNameGoesHere', {type: 'image/png'});
            this.fileUpload = imageFile;
          });
      }
    });
  }

  handlePreview = async (file: NzUploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await this.commonService.getBase64(file.originFileObj!);
    }
    this.previewImage = file.url || file.preview;
    this.previewVisible = true;
  }

  slickInit(e) {
    console.log('slick initialized');
  }

  breakpoint(e) {
    console.log('breakpoint');
  }

  afterChange(e) {
    console.log('afterChange');
  }

  beforeChange(e) {
    console.log('beforeChange');
  }

  log(args: any[]): void {
    console.log(args);
  }

  getBase64(file: File): Promise<string | ArrayBuffer | null> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  pre(): void {
    this.selectedCert = null;
    this.disableButtonSign = true;
    if (this.current === 0) {
      return;
    }
    this.current -= 1;
  }

  next(): void {
    // this.selectedCert = this.imageCertificates[0].listCert[0];
    this.typeCertificate = this.imageCertificates[0].type;
    if (this.typeCertificate == this.signMethod.SIGN_NO_CERT) {
      this.disableButtonSign = false;
    }
    if (!this.fileUpload) {
      this.toastr.error('Chưa có ảnh chữ ký, vui lòng hoàn tất các thao tác');
      return;
    }

    if (this.current === 1) {
      return;
    }
    this.current += 1;
  }

  done(): void {
    console.log('done');
  }

  public getFile(e) {
    if (typeof (FileReader) !== 'undefined') {
      let file: File;
      file = e.target.files[0];
      if (file.type !== 'image/png' && file.type !== 'image/jpeg' && file.type !== 'image/jpg') {
        if (!this.toastr.findDuplicate(this.message.getMessage('messages.only_accept_png_jpg'), true, true)) {
          this.toastr.error(this.message.getMessage('messages.only_accept_png_jpg'));
          this.isDisable = true;
        }
      } else {
        if (file.size <= 10485760) {
          this.checkContentTypeThenAddFile(file);
        } else {
          if (!this.toastr.findDuplicate(this.message.getMessage('validation.file'), true, true)) {
            this.toastr.error(this.message.getMessage('validation.file'));
            this.isDisable = true;
          }
        }
      }
    }
  }

  private checkContentTypeThenAddFile(file: File) {
    FileUtils.getContentType(file)
      // tslint:disable-next-line:no-shadowed-variable
      .then((contentType) => {
        if (ContentType.PNG === contentType || ContentType.BMP === contentType || ContentType.JPEG === contentType) {
          this.fileUpload = file;
          this.imageUrl = URL.createObjectURL(file);
          const reader = new FileReader();
          const image = document.getElementById('#imagePreview');
          if (image) {
            image.setAttribute('src', URL.createObjectURL(file));
          }
          const imageStamp = `<img src="${URL.createObjectURL(file)}" style="height: 100%;"/>`;
          this.stampDivWrapper.innerHTML = imageStamp;
          this.stampDivWrapper.style.background = 'rgb(0, 0, 0, 0)';
        } else {
          this.toastr.error(this.message.getMessage('messages.only_accept_png_jpg'));
          this.isDisable = true;

        }
      }).catch((err) => {
      this.toastr.error(this.message.getMessage('messages.only_accept_png_jpg'));
      this.isDisable = true;

    });
  }

  onSelectFile(Event) {
    this.getFile(Event);
  }

  onNoClick() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '30%',
        data: this.message.getMessage('messages.confirm_change_data')
      });

      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.dialogRef.close();
        }
        dialogRe.close();
      });
    } else {
      this.dialogRef.close();
    }
  }

  createHash(certUserBase64: string) {
    if (this.dataSignSingle !== null) {
      this.sign.certificate = certUserBase64;
      if (this.fileUpload) {
        this.fileToBase64(this.fileUpload).then(base64 => {
          this.sign = {
            ...this.sign,
            ...this.data,
            base64Image: base64
          };
          if (this.sign.signPositions && typeof this.sign.signPositions !== 'string') {
            this.sign.signPositions = JSON.stringify(this.sign.signPositions);
          }
          delete this.sign.image;
          this.documentService.createHashWithImage(this.sign).subscribe(rs => {
            this.sign.path = rs.data.path;
            this.sign.signPdf = rs.data.signPdf;
            // fix sonar
            // this.sign.signature = signHash(this, rs.data.hash);
            if (this.sign.signature) {
              this.signUsb(this.sign);
            }
          });
        });
      } else {
        this.documentService.createHashNoImage(this.sign).subscribe(rs => {
          this.sign.path = rs.data.path;
          this.sign.signPdf = rs.data.signPdf;
          // fix sonar
          // this.sign.signature = signHash(this, rs.data.hash);
          if (this.sign.signature) {
            this.signUsb(this.sign);
          }
        });
      }
    }
  }

  fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve((reader.result as string).split(',')[1]);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  createHashNoImage(certUserBase64: string) {
    if (this.dataSignSingle !== null) {
      this.sign.certificate = certUserBase64;
      this.documentService.createHash(this.sign).subscribe(rs => {
        this.sign.path = rs.data.path;
        this.sign.signPdf = rs.data.signPdf;
        // fix sonar
        // this.sign.signature = signHash(this, rs.data.hash);
        if (this.sign.signature) {
          this.signUsb(this.sign);
        }
      });
    }
  }

  signUsb(certificate: any) {
    this.documentService.signUsb(certificate).subscribe(() => {
      this.onSignSuccess();
    });
  }

  onClickConfirmButton() {
    this.sign = {
      ...this.sign,
      ...this.data
    };
    setTimeout(() => {
      if (this.signType === this.SIGN_SINGLE) {
        if (this.dataSignSingle !== null && this.dataSignSingle.signAll == undefined) {
          this.sign.contractId = this.dataSignSingle;
          this.certificate = this.selectedCert;
          this.sign.digitalCertificateId = this.certificate.id;
          this.sign.digitalCertificateDetailId = this.certificate.idDetail;

          // Sign with signatures server 0
          if (this.certificate.typeCertificate === this.SIGN_SERVER) {
            this.processSignServerNoImage();
          }
          // Sign with Usb Token
          if (this.certificate.typeCertificate === this.SIGN_USB_TOKEN) {
            this.blockUI.start('');
            initPlugin(this);
          }

          // Sign with SIM CA
          if (this.certificate.typeCertificate === this.SIGN_SIM_CA) {
            this.processSignSimCANoImage();
          }

          // Sign with OTP
          if (this.certificate.typeCertificate === this.SIGN_OTP) {
            this.processSignOTP();
          }

          // Sign with HSM
          if (this.certificate.typeCertificate === this.SIGN_HSM) {
            this.processSignHSM();
          }

        } else {
          this.dialogRef.close();
          this.dialog.open(SignProgressComponent, {
            width: '80%',
            data: this.dataSignSingle
          });
        }
      } else if (this.signType === this.SIGN_SLOT) {
        this.actions.next(this.CONFIRM_ACTION);
      }
    }, 400);
  }

  onClickConfirmButtonImage() {
    this.sign = {
      ...this.sign,
      ...this.data,
      image: this.fileUpload
    };
    setTimeout(() => {
      if (!this.selectedCert) {
        this.processSignNoCertificate();
      } else if (this.signType === this.SIGN_SINGLE) {
        if (this.dataSignSingle !== null && this.dataSignSingle.signAll == undefined) {
          this.sign.contractId = this.dataSignSingle;
          this.certificate = this.selectedCert;
          this.sign.digitalCertificateId = this.certificate.id;
          this.sign.digitalCertificateDetailId = this.certificate.idDetail;
          // Sign with signatures server 0

          if (this.certificate.typeCertificate === this.SIGN_SERVER) {
            this.processSignServerImage();
          }
          // Sign with Usb Token
          if (this.certificate.typeCertificate === this.SIGN_USB_TOKEN) {
            this.blockUI.start('');
            initPlugin(this);
          }

          // Sign with SIM CA
          if (this.certificate.typeCertificate === this.SIGN_SIM_CA) {
            this.processSignSimCAImage();
          }

          // Sign with OTP
          if (this.certificate.typeCertificate === this.SIGN_OTP) {
            this.processSignOTP();
          }

          // Sign with HSM
          if (this.certificate.typeCertificate === this.SIGN_HSM) {
            this.processSignHSM();
          }
        } else {
          this.dialogRef.close();
          this.dialog.open(SignProgressComponent, {
            width: '80%',
            data: this.dataSignSingle
          });
        }
      } else if (this.signType === this.SIGN_SLOT) {
        this.actions.next(this.CONFIRM_ACTION);
      }
    }, 400);
  }

  private processSignServer() {
    this.signDocumentService.signatureServer(this.sign).subscribe(rs => {
      this.onSignSuccess();
    });
  }

  private processSignServerImage() {
    this.signDocumentService.signatureServerImage(this.sign).subscribe(rs => {
      this.onSignSuccess();
    });
  }

  processSignSimCA() {
    this.sign.phoneNumber = this.certificate.phoneNumber;
    this.sign.serialNumber = this.certificate.serialNumber;
    this.signDocumentService.signSimCAWithImage(this.sign).subscribe(rs => {
      this.onSignSuccess();
    });
  }

  processSignSimCAImage() {
    this.sign.phoneNumber = this.certificate.phoneNumber;
    this.sign.serialNumber = this.certificate.serialNumber;
    this.signDocumentService.signSimCAWithImage(this.sign).subscribe(rs => {
      this.onSignSuccess();
    });
  }

  processSignOTP() {
    this.signDocumentService.generateTransaction(this.sign.contractId, this.selectedCert.phoneNumber, null).subscribe(rs => {
      this.openDialogConfirmSignOTP(rs.data);
    });
  }

  processSignNoCertificate() {
    this.signDocumentService.signWithImageNoCertificate(this.sign).subscribe(rs => {
      this.onSignSuccess();
    });
  }

  processSignHSM() {
    this.signDocumentService.signHSM(this.sign).subscribe(rs => {
      this.onSignSuccess();
    });
  }

  private onSignSuccess() {
    this.toastr.success(this.message.getMessage('messages.sign_success'));
    this.success = true;
    this.dialogRef.close();
  }

  // ---------- process no image ---------
  processSignSimCANoImage() {
    this.sign.phoneNumber = this.certificate.phoneNumber;
    this.sign.serialNumber = this.certificate.serialNumber;
    this.signDocumentService.signSimCANoImage(this.sign).subscribe(rs => {
      this.onSignSuccess();
    });
  }

  private processSignServerNoImage() {
    this.signDocumentService.signatureServerNoImage(this.sign).subscribe(rs => {
      this.onSignSuccess();
    });
  }

// ---------------------
  handleChange(info: { file: NzUploadFile }): void {
    // this.isFormChanging = true;
    switch (info.file.status) {
      case 'uploading':
        this.loading = true;
        break;
      case 'done':
        // Get this url from response in real world.
        this.getBase64Avatar(info.file!.originFileObj!, (imgUrl: string) => {
          this.loading = false;
          const widthWrapper = parseInt(this.stampDivWrapper.style.width.replace('px', ''));
          const heightWrapper = parseInt(this.stampDivWrapper.style.height.replace('px', ''));
          const img = new Image();
          // Set the src attribute to your URL
          img.src = imgUrl;
          // When the image is loaded, read the available properties
          img.onload = () => {
            // Get  left position
            const newHeightImage = heightWrapper;
            const newWidthImage = (img.width / img.height) * newHeightImage;
            const leftPosition = (widthWrapper - newWidthImage) / 2;
            const imageStamp = `<img src="${imgUrl}" style="height: 100%; position: relative; left: ${leftPosition}px;"/>`;
            this.stampDivWrapper.style.border = 'none';
            this.stampDivWrapper.style.background = 'rgb(0, 0, 0, 0)';
            this.stampDivWrapper.innerHTML = imageStamp;
          };

          this.avatarUrl = imgUrl;
        });
        break;
      case 'error':
        this.toastr.error('Network error');
        this.loading = false;
        break;
    }
  }

  private getBase64Avatar(img: File, callback: (img: string) => void): void {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result!.toString()));
    reader.readAsDataURL(img);
  }

  dummyRequest = ({file, onSuccess, onError}) => {
    this.fileUpload = file;
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  }


  openDialogConfirmSignOTP(transactionId: string) {
    const dialogRef = this.dialog.open(ConfirmSignOtpWithImageComponent, {
      width: '40%',
      data: {
        documentId: this.sign.contractId,
        transaction: transactionId,
        selectedPhone: this.selectedCert.phoneNumber,
        ...this.data,
        image: this.fileUpload
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      if (dialogRef.componentInstance.success) {
        this.toastr.success(this.message.getMessage('messages.sign_success'));
        this.success = true;
        this.dialogRef.close();
      }
    });
  }

  onChangeType() {
    this.selectedCert = null;
    this.stampDivWrapper.innerHTML = '';
    this.stampDivWrapper.style.background = 'rgb(0, 0, 0, 0.2)';
    this.fileUpload = null;
  }

  onClickSignButton() {
    if (!this.fileUpload) {
      this.onClickConfirmButton();
    } else {
      this.onClickConfirmButtonImage();
    }
  }

  onClickCancelButton() {
    if (this.signType === this.SIGN_SINGLE) {
      this.onNoClick();
    } else {
      this.actions.next(this.CLOSE_ACTION);
    }
  }

  getCertificates() {
    this.digitalCertificateService.getCertificates(this.enterpriseId).subscribe(rs => {
      let displayCerts = [];

      if (rs && rs.data) {
        if (this.signType === this.SIGN_SLOT) {
          rs.data.forEach(cert => {
            let check = false;
            cert.listCert.forEach(item => {
              if (Number(item.typeCertificate) === this.SIGN_SERVER) {
                check = true;
              }
            });
            if (check) {
              displayCerts.push(cert);
            }
          });
        } else {
          displayCerts = rs.data;
        }
      }

      this.certificates = displayCerts;
      // if (this.userType == 5) {
      //   this.certificates = [
      //     {
      //       type: 6,
      //       listCert: []
      //     },
      //     ...this.certificates
      //   ]
      // }
      if (this.certificates.length > 0) {
        for (const cerType of this.certificates) {
          cerType.listCert = cerType.listCert.map((item) => {
            const {imagePath} = item;
            if (imagePath) {
              const imageDataBlob = this.commonService.b64toBlob(imagePath);
              const blobUrl = URL.createObjectURL(imageDataBlob);
              return {
                ...item,
                imageUrl: blobUrl
              };
            } else {
              return {
                ...item,
                imageUrl: ''
              };
            }
          });
        }
        // console.log('this.certificates', this.certificates);
        const addSignMethod = [
          {
            type: 5,
            listCert: []
          },
          {
            type: 6,
            listCert: []
          }
        ];

        this.tabsCertificates = [
          ...this.certificates
        ];
        this.imageCertificates = [
          ...this.certificates
        ];
        // nếu là người dùng cá nhân mới cho phép ký bằng ảnh
        if (this.userType == 5) {
          this.imageCertificates = [
            {
              type: 6,
              listCert: []
            },
            ...this.imageCertificates
          ];
        }
        this.certificates = [
          ...this.certificates,
          ...addSignMethod
        ];
        // Select first certificate
        this.typeCertificate = this.imageCertificates[0].type;
        this.selectedCert = this.certificates[0].listCert[0];
        this.listSlickRender = this.certificates[0].listCert;
      }
      this.selectedIndex = 0;
    });
  }

  clearCanvas() {
    this.disableBtnDeleteCanvas = true;
    this.cx.clearRect(0, 0, this.width, this.height);
  }

  onSelectImage(cert: any) {
    const customerName = localStorage.getItem('fullName');
    this.stampDivWrapper.style.border = 'none';
    this.stampDivWrapper.style.background = 'rgb(0, 0, 0, 0)';
    this.selectedCert = cert;
    this.disableButtonSign = false;
    if (!cert.imageUrl) {
      let content = '';
      const signDate = format(new Date(), 'DD/MM/YYYY');
      if (cert.typeCertificate === this.signMethod.SIGN_OTP) {
        // tslint:disable-next-line:max-line-length
        content = `Ký bởi: ${customerName} <br/> Số điện thoại ký:  ${cert.phoneNumber}<br/> Ngày ký: ${signDate}<br/>Xác nhận bởi: Hợp Đồng Điện tử`;
      } else {
        content = `Ký bởi: ${cert.issuedTo} <br/> Ngày ký: ${signDate}`;
      }
      this.stampDivWrapper.innerHTML = content;
    } else {
      const widthWrapper = parseInt(this.stampDivWrapper.style.width.replace('px', ''));
      const heightWrapper = parseInt(this.stampDivWrapper.style.height.replace('px', ''));
      const img = new Image();
      // Set the src attribute to your URL
      img.src = cert.imageUrl;
      // When the image is loaded, read the available properties
      img.onload = () => {
        // Get  width
        const leftPosition = (widthWrapper - img.width * heightWrapper / img.height) / 2;
        this.stampDivWrapper.innerHTML = `<img src="${cert.imageUrl}" style="height: 100%; position: relative; left: ${leftPosition}px;"/>`;
      };

      fetch(cert.imageUrl)
        .then(r => r.blob())
        .then(blobFile => {
          this.fileUpload = new File([blobFile], 'fileNameGoesHere', {type: 'image/png'});
        });
    }

  }

  onSaveCanvas() {
    const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
    const imageUrl = canvasEl.toDataURL();
    this.stampDivWrapper.innerHTML = `<img src="${imageUrl}" style="height: 100%"/>`;
    this.stampDivWrapper.style.border = 'none';
    this.stampDivWrapper.style.background = 'rgb(0, 0, 0, 0)';
    fetch(imageUrl)
      .then(r => r.blob())
      .then(blobFile => {
        this.fileUpload = new File([blobFile], 'fileNameGoesHere', {type: 'image/png'});
      });
  }

  onLoadCanvas(Event) {
    console.log('onload canvas');
  }

  onChangeTabAddNewImage() {
    this.stampDivWrapper.style.border = '1px solid #575757';
    this.stampDivWrapper.innerHTML = '';
    this.stampDivWrapper.style.background = 'rgb(0, 0, 0, 0.2)';
  }

  onSelectDrawSign() {
    this.disableBtnDeleteCanvas = true;
    this.selectNewImageSign = true;
    this.configCanvas();
  }

  onSelectImageSignMethod(type) {
    this.selectedCert = null;
    this.typeCertificate = type;
    this.disableBtnDeleteCanvas = true;

    if (type === this.signMethod.SIGN_NO_CERT) {
      this.disableButtonSign = false;
    } else {
      this.disableButtonSign = true;
    }
  }

  onIndexChangeSignMethodType(index) {
    this.disableBtnDeleteCanvas = true;
    this.disableButtonSign = true;
    this.selectedCert = null;
    this.stampDivWrapper.innerHTML = '';
    this.stampDivWrapper.style.border = '1px solid #575757';
    this.stampDivWrapper.style.background = 'rgb(0, 0, 0, 0.2)';
    this.fileUpload = null;
    if (index === 0) {
      this.selectNewImageSign = false;
    } else {
      this.selectNewImageSign = true;
      this.configCanvas();
    }
  }

  onSelectSignMethodNoImage(cert) {
    // this.listSlickRender = this.certificates.filter(item => item.type = type);
    this.listSlickRender = cert.listCert;
    this.stampDivWrapper.style.border = '1px solid #575757';
    this.stampDivWrapper.style.background = 'rgb(0, 0, 0, 0.2)';
    this.fileUpload = null;
    this.disableBtnDeleteCanvas = true;
    this.disableButtonSign = true;
  }

  onChangeSubType(cert: any) {
    this.disableButtonSign = false;
  }
}

